import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import FeedPostSlider from 'src/app/molecules/FeedPostSlider/FeedPostSlider';
import { IStaticContentfulImages } from 'src/types/contentful';

const imageMaxWidth = 336;

const TheirOwnWordsFeed = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      image0: contentfulAsset(contentful_id: { eq: "3IccyfTLxfZLfTPW8TTMd1" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image1: contentfulAsset(contentful_id: { eq: "3AURmhcugw3ul4TwXeusy0" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image2: contentfulAsset(contentful_id: { eq: "5hgndOh77hOWofH8b2r1W8" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image3: contentfulAsset(contentful_id: { eq: "7w6Bd0KW1InGXOo3JJl3lR" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image4: contentfulAsset(contentful_id: { eq: "2WqLdI8uqnfbtzRdJy0C4J" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image5: contentfulAsset(contentful_id: { eq: "2euLnc6xOV1gkNOi2XnEjH" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image6: contentfulAsset(contentful_id: { eq: "4MsIyQW2UZTXccc96D88Cu" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image7: contentfulAsset(contentful_id: { eq: "3KVpZdr0DPSwKW1i0ZoNVh" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image8: contentfulAsset(contentful_id: { eq: "2Lwnc660CZFqnifrTKifei" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image9: contentfulAsset(contentful_id: { eq: "6Zbkvu8t5gkYe5ksJJF80D" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
    }
  `);

  const posts = [
    {
      image: {
        image: images.image0.gatsbyImageData,
        alt: 'Community on Mighty',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image1.gatsbyImageData,
        alt: 'Community on Mighty',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image2.gatsbyImageData,
        alt: 'Community on Mighty',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image3.gatsbyImageData,
        alt: 'Community on Mighty',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image4.gatsbyImageData,
        alt: 'Community on Mighty',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image5.gatsbyImageData,
        alt: 'Community on Mighty',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image6.gatsbyImageData,
        alt: 'Community on Mighty',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image7.gatsbyImageData,
        alt: 'Community on Mighty',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image8.gatsbyImageData,
        alt: 'Community on Mighty',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image9.gatsbyImageData,
        alt: 'Community on Mighty',
      },
      imageMaxWidth,
    },
  ];

  return <FeedPostSlider posts={posts} />;
};

export default TheirOwnWordsFeed;
